<!--
    Created by 王丽莎 on 2024/08/29.
    Copyright © 2023年 云柜-金星晖. All rights reserved.
    界面名称：运营管理-充电桩计费模版-模版下发记录
-->
<style lang="less">
#billing-template-record {
  .text-color-error {
    color: @errorColor;
    font-weight: 600;
  }
}
</style>

<template>
  <yg-drawer
    :show-bottom="false"
    width="90%"
    :back-type="1"
    title="模版下发记录"
    @on-close="_close"
  >
    <div
      id="billing-template-record"
      slot="content"
    >
      <!--查询条件-->
      <div v-permission="'system:admin:template:getComputeFeeIssueList'">
        <yg-search-area
          :show-info="false"
          :value="searchOption"
          @on-search="_clickSearch"
        />
      </div>
      <div class="setting-area">
        <yg-setting-area
          :items="settingItems"
          :total="page.total"
          @on-click="_clickSetting"
        />
      </div>
      <div
        v-permission="'system:admin:template:getComputeFeeIssueList'"
        class="padding-primary-top"
      >
        <yg-table
          :columns="tableColumns"
          :data="tableData"
          :page="page"
          @on-page-change="onChangePage"
        />
      </div>
      <v-template
        v-if="dialog.templateModel"
        :model="dialog.templateModel"
        @on-close="dialog.templateModel = null"
      />
    </div>
  </yg-drawer>
</template>

<script>
import { BillingTemplateDetailModel, BillingTemplateRecordListModel } from '../model/BillingTemplateDataModel';
import ColumnMixin from '../mixin/recordTableColumn';
import vTemplate from '../view/template.vue';
import OperationsApiSet from '@/request/api/OperationsApiSet';
import DownloadApiSet from '@/request/api/DownloadApiSet';

export default {
  name: 'BillingTemplateRecord',
  components: { vTemplate },
  mixins: [ColumnMixin],
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      searchOption: {
        templateName: BaseSearchModel.initData('模版名称', 'templateName', 'Input'),
        category: BaseSearchModel.initData('计费类型', 'category', 'Select').setData([
          { label: '按功率计费', value: 1 },
          { label: '按电量计费', value: 2 },
          { label: '按时间计费', value: 3 },
          { label: '按电量计费（新）', value: 4 }
        ])
      },
      settingItems: [
        BaseSettingModel.initData('刷新列表', 'refresh', 'md-refresh').setPermission('system:admin:template:getComputeFeeIssueList')
      ],
      page: { current: 1, total: 0 },
      tableData: [],
      tableSort: null,
      dialog: {
        templateModel: null
      }
    };
  },
  created () {},
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onChangePage (page, sortDic) {
      this.page.current = page;
      if (sortDic) {
        this.tableSort = sortDic;
      }
      this.requestData();
    },
    _clickSetting (key) {
      console.log(key);
      if (key === 'refresh') {
        this.page.current = 1;
        this.requestData();
      }
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    _clickSearch (option) {
      this.searchOption = option;
      this.page.current = 1;
      this.requestData();
    },
    _close () {
      this.$emit('on-close');
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    // 请求列表
    requestData () {
      this.tableData = [];
      this.page.total = 0;
      const api = OperationsApiSet.getComputeFeeIssueList;
      const s = this.searchOption;
      api.params = {
        timeAsc: '', // 排序在下面赋值，判断tableSort变量
        templateName: s.templateName.value,
        category: s.category.value,
        pageSize: this.$config.pageSize,
        pageNo: this.page.current
      };
      if (this.tableSort) {
        api.params[this.tableSort.sortReqKey] = this.tableSort.sortReqValue;
      }
      this.$http(api).then(res => {
        const resData = res.data;
        this.page.total = resData.total;
        this.tableData = BillingTemplateRecordListModel.initListWithDataList(resData.rows);
        // const resData = BillingTemplateRecordListModel.createFakeDataList();
        // this.tableData = BillingTemplateRecordListModel.initListWithDataList(resData);
      });
    },
    // 请求详情
    requestDetail (templateId, key) {
      const api = OperationsApiSet.getComputeFee;
      api.params = {
        templateId
      };
      console.log(api);
      this.$http(api).then(res => {
        const resData = res.data;
        this.dialog[key] = BillingTemplateDetailModel.initModelWithData(resData);
        // const resData = BillingTemplateDetailModel.createFakeData();
        // this.dialog[key] = BillingTemplateDetailModel.initModelWithData(resData);
      });
    },
    // 请求导出
    requestDownload (id) {
      if (this.tableData.length === 0) {
        return this.$Message.warning({
          title: '无数据可导出',
          content: '请先查询到结果后再进行导出',
          okText: '我知道了'
        });
      }
      const api = DownloadApiSet.downloadCreate;
      api.params = {
        reportType: 29,
        reportCondition: {
          templateConfigRecordId: id
        }
      };
      this.$http(api).then(res => {
        this.$Modal.confirm({
          title: '操作成功',
          content: '请至下载中心导出',
          okText: '立即前往',
          cancelText: '稍后前往',
          onOk: () => {
            this.$router.push({
              name: 'download_list'
            });
          }
        });
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
